import _ from 'lodash';
import { determineErrorFromResponse, isEpisode } from 'helpers/ContentHelper';
import { FORMAT_TIME, format, now } from 'helpers/DateTimeHelper';
import { parseLiveVideoResponse } from './LiveHelpers';
import {
  CLEAR_LIVE,
  FETCH_LIVE_PANEL,
  FETCH_LIVE,
  FETCH_LIVESTREAM,
  FETCH_LIVE_NEXT_PAGE,
  FETCH_PRIME_TIME,
  RESTORE_LIVE_GRID_STATE,
  SAVE_LIVE_VIDEO,
  SET_SUGGESTED_CHANNEL,
} from './LiveActions';

const INITIAL_STATE = {
  panels: null,
  seo: null,
  errors: null,
  video: null,
  defaultChannel: null,
  defaultChannelVideo: null,
  currentTime: null,
  primeTimePanels: null,
  upNext: null,
  prevOpenRow: null,
  prevRowIdx: null,
  savedVideo: null,
};

export default function(state = INITIAL_STATE, action) {
  const errors = determineErrorFromResponse(action);
  const data = _.get(action, 'payload.data');
  const responseURL = _.get(action, 'payload.request.responseURL', '');
  const network = _.get(data, 'network');
  const videoId = _.get(data, 'videoId');
  const programId = _.get(data, 'programId');
  const seo = _.get(data, 'SEO');
  const currentTime = format(now(), FORMAT_TIME);

  let panels;
  switch (action.type) {
    case FETCH_LIVE:
      if (!data) return state;
      panels = _.get(data, 'panels');
      return {
        ...state,
        panels,
        seo,
        errors,
        currentTime,
      };
    case FETCH_LIVE_PANEL: {
      const { panels: prevPanels } = state;
      if (!data || !prevPanels) return state;
      const member = _.map(prevPanels.member, panel => (panel.id === data.id ? data : panel));
      panels = prevPanels;
      panels.member = member;
      return { ...state, panels };
    }

    case FETCH_LIVE_NEXT_PAGE: {
      const { panels: prevPanels } = state;
      if (!data || !prevPanels) return state;
      const { member: nextMember } = data;
      const channels = _.map(prevPanels.member, channel => {
        let newChannel = channel;
        if (channel.callSign === nextMember[0].callSign) {
          const member = _.get(channel, 'items.member');
          const members = [...member, ...nextMember];
          const dataMap = {};
          const cleanMap = [];
          members.forEach(item => {
            const gapFillerId = `gapFiller${item.startDate}${item.endDate}`;
            if (!dataMap[item.id] || (item.id === 'gapFiller' && !dataMap[gapFillerId])) {
              dataMap[item.id === 'gapFiller' ? gapFillerId : item.id] = true;
              cleanMap.push(item);
            }
          });
          newChannel = {
            ...channel,
            items: {
              member: cleanMap,
            },
          };
        }
        return newChannel;
      });
      panels = prevPanels;
      panels.member = channels;
      return { ...state, panels };
    }

    case FETCH_PRIME_TIME: {
      if (!data) return state;
      // get the requested date range
      let dateRange = null;
      let date = null;
      let usingLocation = null;
      if (responseURL) {
        const reg = /dateRange=(.+?)(&|$)/;
        const result = responseURL.match(reg);
        dateRange = result ? result[1] : dateRange;
        date = dateRange ? dateRange.match(/([\d]{4}-[\d]{2}-[\d]{2})/)[1] : date;
        usingLocation = responseURL.indexOf('geoLatitude') !== -1;
      }

      // add the date range to the panel.
      const primeTimePanels = _.get(data, 'panels', null);
      if (primeTimePanels) {
        primeTimePanels.dateRange = dateRange;
        primeTimePanels.date = date;

        // add if it used location
        primeTimePanels.usingLocation = usingLocation;
      }
      return {
        ...state,
        primeTimePanels,
        errors,
      };
    }
    case FETCH_LIVESTREAM: {
      const { liveVideo, panel } = parseLiveVideoResponse(data);
      const videoType = _.get(liveVideo, 'videoType');
      const isFullEpisode = isEpisode(videoType);
      const video = liveVideo ? { ...liveVideo, isFullEpisode } : null;
      return {
        ...state,
        video,
        panel,
        errors,
      };
    }
    case SAVE_LIVE_VIDEO: {
      const video = _.get(action, 'payload', null);
      return {
        ...state,
        savedVideo: video,
      };
    }
    case SET_SUGGESTED_CHANNEL:
      return {
        ...state,
        defaultChannel: network,
        defaultChannelVideo: videoId,
        defaultProgram: programId,
      };
    case CLEAR_LIVE: {
      return {
        ...state,
        ...INITIAL_STATE,
      };
    }
    case RESTORE_LIVE_GRID_STATE: {
      const prevOpenRow = _.get(action, 'payload.prevOpenRow', null);
      const prevRowIdx = _.get(action, 'payload.prevRowIdx', null);
      return {
        ...state,
        prevOpenRow,
        prevRowIdx,
      };
    }
    default:
      return state;
  }
}
